import React from 'react';
import immJs from 'lodash';
import moment from 'moment';
import { FormattedMessage, defineMessages } from 'react-intl';
import PropTypes from 'prop-types';
import './EventContentComponent.scss';

const messages = defineMessages({
  status: {
    id: 'EventContent.Status',
    defaultMessage: 'Status',
  },
  inPerson: {
    id: 'EventToolTip.Text.InPerson',
    defaultMessage: 'In Person',
  },
  onCall: {
    id: 'EventToolTip.Text.OnCall',
    defaultMessage: 'On Call',
  },
});

function EventContent(props) {
  let eventContent;
  let isLocationPlace;
  let locationMessage = '';
  let { startTime, endTime } = props;
  const { type, parent, event, candidates, eventStatusText } = props;
  const candidateDetails = `${
    candidates.length > 1
      ? `${candidates[0].email}, +${candidates.length - 1} more;`
      : `${immJs.get(candidates,'email', '')}`
  }`;
  const duration = (moment(endTime).valueOf() - moment(startTime).valueOf()) / 1000;
  startTime = moment(startTime).format('hh:mm a');
  endTime = moment(endTime).format('hh:mm a');
  if (immJs.get(props, 'event.Location', false)) {
    const pattern = /[A-za-z]/;
    isLocationPlace = pattern.test(event.Location);
    if (isLocationPlace) {
      locationMessage = <FormattedMessage {...messages.inPerson} />;
    } else {
      locationMessage = <FormattedMessage {...messages.onCall} />;
    }
  }
  if (type === 'arya') {
    if (parent === 'in-day') {
      if (duration >= 3600) {
        eventContent = (
          <div className="event-content">
            <div className="event-week">
              {event.Summary}; {startTime}-{endTime};
            </div>
            <div className="event-week">
              {locationMessage}; {candidateDetails}
            </div>
            <div className="event-week">
              <span className="status-text">
                {' '}
                <FormattedMessage {...messages.status} />: {eventStatusText}{' '}
              </span>
            </div>
          </div>
        );
      } else if (duration >= 1800 && duration <= 3600) {
        eventContent = (
          <div className="event-content">
            <div className="event-week">
              {event.Summary}; {startTime}-{endTime}; {locationMessage}; {candidateDetails}
            </div>
            <div className="event-week">
              <span className="status-text">
                {' '}
                <FormattedMessage {...messages.status} />: {eventStatusText}{' '}
              </span>
            </div>
          </div>
        );
      } else {
        eventContent = (
          <div className="event-content">
            <div className="event-week">
              {event.Summary}; ({startTime}-{endTime}); {locationMessage};{candidateDetails}{' '}
              <span className="status-text">
                {' '}
                <FormattedMessage {...messages.status} />: {eventStatusText}{' '}
              </span>
            </div>
          </div>
        );
      }
    } else {
      eventContent = (
        <div className="event-content">
          <div className="event-week">
            {props.event.Summary}; ({startTime}-{endTime}); {locationMessage} ; {props.candidates.join(',')}{' '}
            <span className="status-text">
              {' '}
              <FormattedMessage {...messages.status} />: {props.eventStatusText}{' '}
            </span>{' '}
          </div>
        </div>
      );
    }
  } else {
    eventContent = (
      <div className="event-content">
        <div className="event-week">
          ({startTime}-{endTime})
        </div>
      </div>
    );
  }
  return <React.Fragment>{eventContent}</React.Fragment>;
}

EventContent.propTypes = {
  parent: PropTypes.string,
  startTime: PropTypes.shape({}),
  endTime: PropTypes.shape({}),
  event: PropTypes.shape({
    Summary: PropTypes.string,
    Location: PropTypes.string,
  }),
  type: PropTypes.string,
  eventStatusText: PropTypes.string,
  candidates: PropTypes.arrayOf(
    PropTypes.shape({
      email: PropTypes.string,
      role: PropTypes.string,
      status: PropTypes.String
    })
  ),
};

EventContent.defaultProps = {
  parent: '',
  startTime: {},
  endTime: {},
  event: {
    Summary: '',
    Location: '',
  },
  type: '',
  eventStatusText: '',
  candidates: [],
};

export default EventContent;
